import React, { useId } from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { logoMonogramPathD } from "../Svg";

import styles from "./index.module.scss";

interface CustomCss extends React.CSSProperties {
    "--clip-path"?: string;
}

export const LogoLoader = ({ className }: { className?: string }) => {
    const id = useId();

    return (
        <div
            className={concatClassNames([styles.root, className])}
            aria-hidden="true"
        >
            <svg
                width="0"
                height="0"
                viewBox="0 0 87 91"
                className={styles.referenceSvg}
            >
                <defs>
                    <clipPath
                        id={`logo-clip-${id}`}
                        clipPathUnits="userSpaceOnUse"
                    >
                        <path d={logoMonogramPathD} />
                    </clipPath>
                </defs>
            </svg>
            <div
                className={styles.logo}
                style={{ "--clip-path": `url(#logo-clip-${id})` } as CustomCss}
            />
        </div>
    );
};
